import Vue from "vue";
import axios from "axios";
import qs from "qs";
import commonUrl from "./commonUrl";
import { showLoading, hideLoading } from "./loading";
// import md5 from "js-md5";
import { Message } from "element-ui";

Vue.prototype.qs = qs;

// axios.defaults.headers['Content-Type'] = 'multipart/form-data';
// 创建axios实例
const service = axios.create({
  timeout: 300000 // 请求超时时间
});

service.defaults.retry = 3;
service.defaults.retryDelay = 100000;
service.defaults.baseURL = "/api";
// service.defaults.withCredentials = false; // 是否携带cookie信息

/* axios.defaults.baseURL = "/api";
axios.defaults.timeout = 100000;
// axios.defaults.withCredentials = false; // 是否携带cookie信息 */

// 添加请求拦截器
// axios.interceptors.request.use(
service.interceptors.request.use(
  config => {
    if (process.env.VUE_APP_MODE === "development") {
      if (config.baseURL === "/api") {
        config.baseURL = commonUrl.baseurl;
      } else if (config.baseURL === "/login") {
        config.baseURL = commonUrl.login_baseurl;
      } else if (config.baseURL === "/contactshowview") {
        config.baseURL = commonUrl.imurl_baseurl;
      }
    } else {
      // config.baseURL = commonUrl.baseurl;
      config.baseURL = commonUrl.baseurl + config.baseURL;
    }
    if (config.method == "get") {
      let token = sessionStorage.getItem("token");
      // let timestamp = new Date().valueOf();
      // let signature
      // if(sessionStorage.getItem('Authorization')) {
      //   signature = md5(timestamp + sessionStorage.getItem('Authorization'))
      // }
      config.params = {
        token: token,
        // timestamp: timestamp,
        // signature: signature,
        ...config.params
      };
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
// request 请求拦截器
/* service.interceptors.request.use(config => {
  config.baseURL = resultBaseURL(config.baseURL)
  return config
}) */

/* 请求拦截器（请求之前的操作） */
service.interceptors.request.use(
  req => {
    if (req.url !== "/getPartsBySearchKey" && req.url !== '/parts' && req.url !== '/getSupplierPartInfo') {
      showLoading();
    }
    return req;
  },
  err => Promise.reject(err)
);

// response 响应拦截器
service.interceptors.response.use(
  response => {
    // let resCode = response.data.code;
    hideLoading();
    return response;
  },
  error => {
    hideLoading();
    Message.error("网络错误！");
    return Promise.reject(error);
  }
);

// /* 请求之后的操作 */
// axios.interceptors.response.use(
//   res => {
//     hideLoading();

//     return res;

//     return Promise.reject(res);
//   },
//   err => {
//     hideLoading();
//     return Promise.reject(err);
//   }
// );

function request(config, request) {
  //console.log(config);
  //console.log(request);
  let data = config.data; // 请求参数
  if (request && request.parse) {
  } else {
    data = qs.stringify(config.data); // 序列化为formData参数
    config.data = data;
  }
  return service(config);
}

// Vue.prototype.axios = axios;
export default request;
